import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { useLayoutStyles } from '../layouts/layout-context';

export const Wrap = ({ children }: { children: ReactNode }) => {
  const s = useLayoutStyles('shared');

  return <Box sx={s.wrap}>{children}</Box>;
};
